module.exports = __webpack_public_path__ + "static/media/Plus-Red-Secondary.476a38aa.svg";